import { proxy } from 'valtio'

interface InactivityStatus {
  isIdle: boolean
  timerExpired: boolean
  forceLogout: boolean
}

interface AppStatus {
  isReady: boolean
  inactivityStatus: InactivityStatus
}

const state = proxy<AppStatus>({
  isReady: false,
  inactivityStatus: {
    isIdle: false,
    timerExpired: false,
    forceLogout: false,
  },
})

const setAppIsReady = (isReady: boolean) => {
  state.isReady = isReady
}

const setInactivityStatus = (status: Partial<InactivityStatus>) => {
  state.inactivityStatus = { ...state.inactivityStatus, ...status }
}

const resetInactivityStatus = () => {
  state.inactivityStatus = { isIdle: false, timerExpired: false, forceLogout: false }
}

export const useAppStatus = () => {
  return {
    status: state,
    setAppIsReady,
    resetInactivityStatus,
    setInactivityStatus,
  }
}
